import { render, staticRenderFns } from "./BCXPagination.vue?vue&type=template&id=34ff3d44"
import script from "./BCXPagination.vue?vue&type=script&lang=ts"
export * from "./BCXPagination.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports